import { useMutation } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { CreateSessionBody, CreateSessionResponse } from '@/types'
import { MutationOptions } from '@/api/react-query'

async function createSession(body: CreateSessionBody) {
  const response = await httpClient('user-manager').post(
    '/v1/session/password',
    body,
  )

  return response.data
}
export function useCreateSession(
  options?: MutationOptions<CreateSessionResponse, CreateSessionBody>,
) {
  return useMutation({
    mutationFn: createSession,
    ...options,
  })
}
